import { UsersService } from '../../../modules/usermanagement/service/users/users.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, exhaustMap, catchError } from 'rxjs/operators';
import * as allActions  from '../../actions';


@Injectable()
export class GetDepartmentByIdEffects {
    constructor(
        private actions$: Actions,
        private UserService: UsersService,
    ){ }
    GetDepartmentById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(allActions.GetDepartmentById),
    exhaustMap(action =>
    this.UserService.GetDepartmentById({body:action}).pipe(
      map(response =>
        {
      return allActions.GetDepartmentByIdSuccess({response})
          }),
          catchError((error: any) => of(allActions.GetDepartmentByIdFailure(error))))
      )
    )
  );

}
